import { apiClient } from '@/shared/lib/apiClient';
import type { ApiResponse, GuideOwnIdentityPayload, PublicGuideIdentityPayload } from '@/types';

export const guideIdentityApi = {
  async getPublic(code: string): Promise<PublicGuideIdentityPayload> {
    const response = await apiClient.get<ApiResponse<PublicGuideIdentityPayload>>(
      `/guides/identity/${encodeURIComponent(code)}`
    );
    return response.data.data!;
  },

  async getOwn(): Promise<GuideOwnIdentityPayload> {
    const response = await apiClient.get<ApiResponse<GuideOwnIdentityPayload>>('/guide/identity');
    return response.data.data!;
  },
};

export const guideIdentityKeys = {
  all: ['guide-identity'] as const,
  public: (code: string) => [...guideIdentityKeys.all, 'public', code] as const,
  own: () => [...guideIdentityKeys.all, 'own'] as const,
};
